import { Vue, Component } from 'vue-property-decorator'
import StaticPageImageFooter from '~/components/element/StaticPageImageFooter'
import s from '~/utils/s'

@Component
export default class DeliveryPayment extends Vue {
  renderContent () {
    return (
      <div class="delivery-payment-page__content" domPropsInnerHTML={s(this.$store).staticPages.staticPage.HTMLContent}></div>
    )
  }

  render () {
    return (
      <div class="delivery-payment-page custom-content">
        {this.renderContent()}
        <StaticPageImageFooter v-zoom-image
          props={{
            images: s(this.$store).staticPages.staticPage.images,
            blockName: s(this.$store).staticPages.staticPage.imagesBlockName
          }} />
      </div>
    )
  }
}
